import ApiClient from "../backends/ApiClient";
import { refreshClientRouter } from "../actions/refreshClientRouter";

export function useCreateContentItem() {
  async function handleSave(
    contentItem,
    organization,
    post_to_facebook: boolean,
  ) {
    const client = await ApiClient();
    await client.POST("/organizations/{organization_pk}/content-items/", {
      params: {
        path: { organization_pk: organization.id },
        query: { post_to_facebook },
      },
      body: contentItem,
    });
    await refreshClientRouter();
  }

  return { handleSave };
}
